export const handleTab = {
	inserted(el) {
		function handleFirstTab(e) {
			if (e.keyCode === 9) {
				el.classList.add('user-is-tabbing');

				window.removeEventListener('keydown', handleFirstTab);
				window.addEventListener('mousedown', handleMouseDownOnce);
			}
		}

		function handleMouseDownOnce() {
			el.classList.remove('user-is-tabbing');

			window.removeEventListener('mousedown', handleMouseDownOnce);
			window.addEventListener('keydown', handleFirstTab);
		}

		window.addEventListener('keydown', handleFirstTab);
	}
};



// WEBPACK FOOTER //
// ./src/directives/handle-tab.js